module.exports = __webpack_public_path__ + "assets/h3.1fcb4711.svg";